import { render, staticRenderFns } from "./request-status-label.vue?vue&type=template&id=132b4c99&scoped=true&"
import script from "./request-status-label.vue?vue&type=script&lang=js&"
export * from "./request-status-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b4c99",
  null
  
)

export default component.exports